
import { computed, defineComponent, ref } from 'vue';
import { useRouter } from 'vue-router';
import { toRussianLocaleDateFromIso, removeHtml, toRussianDate } from '@packages/toolbox';
import { useImageFallback } from 'SharedDir/common/composables/useImageFallback';
import { cropTextSmart } from 'SharedDir/utils/helpers';

export default defineComponent({
  name: 'NewsItem',
  props: {
    news: {
      type: Object,
      required: true,
    },
    iconNumber: {
      type: Number,
      required: false,
      default: 0,
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props) {
    const router = useRouter();

    const getNewsName = computed(() => {
      return props.news?.title ?? '';
    });

    const getNewsDescription = computed(() => {
      return cropTextSmart(removeHtml(props.news?.shortDescription), 172) ?? '';
    });

    const getNewsDate = computed(() => {
      return props.news?.publishedAt ? toRussianLocaleDateFromIso(props.news?.publishedAt) : '';
    });

    const getNewsSource = computed(() => {
      return props.news?.source ?? '';
    });

    function goToNews() {
      return {
        name: 'news-view',
        params: {
          newsId: (props.news.id as number).toString(),
        },
      };
    }

    const { getImage, imageNotLoading } = useImageFallback();

    return {
      props,
      getNewsName,
      getNewsDate,
      goToNews,
      getNewsDescription,
      getImage,
      imageNotLoading,
      getNewsSource,
    };
  },
});
